// extracted by mini-css-extract-plugin
export default {"funnelIcon":"CrmGridSimpleFilterButton_funnelIcon__qbo0o","funnelIconFull":"CrmGridSimpleFilterButton_funnelIconFull__Ch+cZ"};